import { useLang } from "@/i18n/LangContext";
import { IMAGES } from "@/lib/images";
import { MapPin, Waves, Home, Maximize2, Users, Car } from "lucide-react";

const icons = [MapPin, Waves, Home, Maximize2, Users, Car];

export default function Highlights() {
  const { t } = useLang();
  return (
    <section id="suite" data-testid="highlights-section" className="py-24 sm:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-5">
              {t.highlights.overline}
            </p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#121C26]">
              {t.highlights.title}
            </h2>
            <p className="mt-6 text-[#4A5D6B] text-base sm:text-lg leading-relaxed max-w-md">
              {t.highlights.welcome}
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-[#E0DACE]">
              {t.highlights.items.map((it, idx) => {
                const Icon = icons[idx] || MapPin;
                return (
                  <div
                    key={it.label}
                    data-testid={`highlight-${idx}`}
                    className="bg-[#FAF9F6] p-8 sm:p-10 group hover:bg-[#F0EDE6] transition-colors"
                  >
                    <Icon
                      size={22}
                      strokeWidth={1.25}
                      className="text-[#0097b2] mb-6"
                    />
                    <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-2">
                      {it.label}
                    </p>
                    <p className="font-serif text-2xl text-[#121C26] leading-snug">
                      {it.value}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div data-testid="highlight-photo-0" className="aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.living}
              alt="Soggiorno"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <div data-testid="highlight-photo-1" className="aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.terrace}
              alt="Terrazzo"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <div data-testid="highlight-photo-2" className="aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.dining}
              alt="Sala da pranzo"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
